import { requestPost } from '@/common/request';

interface ResultData {
  data: any;
}

interface reqParams {
  marketTypeConfigParams?: MessageSubsrcibeParam[];
}

type MessageSubsrcibeParam = {
  marketType: string; //1=主题活动,3=京东秒杀,5=PLUS会员,6=其他频道,7=会场活动,8=综合促销,10=百亿补贴,11=便宜包邮,12=新品小魔方,13=京东直播,14=微信域
  isSubscribe: number; //	是否订阅 否 默认订阅
};

/**
 * 消息中心
 * 接口文档：https://cf.jd.com/pages/viewpage.action?pageId=1306832381&spaceEditingRestriction=true
 */
export default function genericMsgSubcribeStatus(query: reqParams): Promise<RequestResult<ResultData>> {
  return requestPost('/generic/platMktMsgBk/message/saveMarketTypeConfig', query);
}
